import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * Comparator function for AG Grid's date filter.
 * Compares a cell's UTC date value to the filter's local date, using only the date part (YYYY-MM-DD).
 * cellValue must be a UTC ISO string (e.g., "YYYY-MM-DDTHH:mm:ss.sssZ")
 * filterLocalDateAtMidnight is a local JS Date (from AG Grid filter)
 */
export const filterDateComparator = (
  filterLocalDateAtMidnight: Date,
  cellValue: string | null
) => {
  // If the cell value is null, treat as equal (no filtering)
  if (cellValue === null) {
    return 0;
  }

  // Parse the cell value as a UTC date
  const cellDate = dayjs.utc(cellValue);

  // If the cell value is not a valid date, treat as equal (no filtering)
  if (!cellDate.isValid()) {
    return 0;
  }

  // Parse the filter date (already local time)
  const filterDateLocal = dayjs(filterLocalDateAtMidnight);

  // Format both dates as 'YYYY-MM-DD' strings for comparison (ignores time and timezone)
  const cellDateStr = cellDate.format('YYYY-MM-DD');
  const filterDateStr = filterDateLocal.format('YYYY-MM-DD');

  // Compare the date strings lexicographically
  if (cellDateStr < filterDateStr) return -1;
  if (cellDateStr > filterDateStr) return 1;
  return 0;
};
